import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { FORM, LAYOUT_ITEM, YUP } from 'constants/FormConstants';
import { CheckboxLayoutItem, SelectLayoutItem, TextFieldLayoutItem } from 'models/InputLayoutItem';
import * as yup from 'yup';
import React, { useEffect } from 'react';
import { useFinancialInstitutionServices } from 'hooks/useFinancialInstitutionServices';
import { FinancialInstitutionDto } from 'client';
import { DATA_LAYERS } from 'constants/DataLayers';
import { DataLayerMarkupProps } from 'models/props/DataLayerMarkupProps';
import TagManager from 'react-gtm-module';
import getYearOptions from 'utils/GetYearOptions';

const createFinancialInstitutionList = (financialInstitutions?: FinancialInstitutionDto[]) => {
	return financialInstitutions?.map((financialInstitution) => {
		return {
			value: financialInstitution.id?.toString(),
			label: financialInstitution.name,
		};
	});
};

export const RefinancingVehicleForm = ({ dataLayerKey }: DataLayerMarkupProps) => {
	const { financialInstitutions, getFinancialInstitutions } = useFinancialInstitutionServices();

	const fields: any[] = [
		{
			defaultValue: '',
			label: 'Nombre de la financiera',
			name: FORM.FINANCIAL_INSTITUTION,
			type: LAYOUT_ITEM.TYPE.SELECT,
			//options: FinancialList,
			options: createFinancialInstitutionList(financialInstitutions),
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			label: 'Nº de cuotas pagadas',
			defaultValue: '',
			name: FORM.INSTALLMENT_NUMBER,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: '36',
			mask: '##',
			validation: yup
				.number()
				.typeError('Ingrese un número válido')
				.required('Campo Requerido')
				.min(1, 'Ingrese un número válido')
				.max(60, 'Ingrese un número válido'),
		} as TextFieldLayoutItem,
		{
			label: 'Valor del vehículo ',
			defaultValue: '',
			name: FORM.VEHICLE_VALUE,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '$',
			mask: 'money',
			placeholder: ' Ej: 9.000.000',
			validation: yup
				.number()
				.required('Campo Requerido')
				.typeError('Campo Requerido')
				.min(3000000, 'Ingrese un valor superior a 3.000.000'),
		} as TextFieldLayoutItem,
		{
			defaultValue: '',
			label: 'Año del vehículo',
			name: FORM.VEHICLE_YEAR,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: getYearOptions(),
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			label: 'Sueldo líquido',
			defaultValue: '',
			name: FORM.SALARY,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '$',
			mask: 'money',
			tooltip: 'Suma de dinero que recibes como sueldo a fin de mes.',
			placeholder: ' Ej: 900.000',
			validation: yup
				.number()
				.required('Campo Requerido')
				.typeError('Campo Requerido')
				.min(600000, 'Sueldo  mínimo $600.000'),
		} as TextFieldLayoutItem,
		{
			defaultValue: false,
			label: '',
			name: FORM.CONSENT_CHECKED,
			type: LAYOUT_ITEM.TYPE.CONSENT_CHECKBOX,
			validation: yup.boolean().required(YUP.CONSENT_ACCEPT).oneOf([true], YUP.CONSENT_ACCEPT),
		} as CheckboxLayoutItem,
	];

	useEffect(
		() => {
			getFinancialInstitutions();
		},
		// eslint-disable-next-line
		[]
	);
	useEffect(
		() => {
			if (dataLayerKey) {
				TagManager.dataLayer({
					dataLayer: DATA_LAYERS.get(dataLayerKey),
				});
			}
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Información del vehículo"
				body="Ingresa los datos del vehículo que quieres refinanciar."
			/>
			<CreateFormLayout key={fields.length} fields={fields} />
		</div>
	);
};
